module.exports = __webpack_public_path__ + "img/2021_10_dande_TVasa_0907-2_fin_web.c21c2fab.jpg";